import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  BadPackageType: {
    description: 'labelBatchErrors.badPackageType',
    defaultMessage: 'The package type for the shipment is not set or is invalid',
    id: 'G0DIQ4',
  },
  AlreadyShipped: {
    description: 'labelBatchErrors.alreadyShipped',
    defaultMessage: 'This fulfillment has already been shipped',
    id: 'aJ1WL1',
  },
  NoServiceSelected: {
    description: 'labelBatchErrors.noServiceSelected',
    defaultMessage: 'Please select a service',
    id: 'obbDXu',
  },
  InventoryWarning: {
    description: 'labelBatchErrors.inventoryWarning',
    defaultMessage: 'There is not sufficient inventory to fulfill this shipment',
    id: 'SGSqho',
  },
  PendingStampsVerification: {
    description: 'labelBatchErrors.pendingStampsVerificiation',
    defaultMessage: 'Account pending verification, try again in 2 minutes',
    id: 'Vg8EOv',
  },
  houseAccountError: {
    description: 'labelBatchErrors.stampsHouseAccountError',
    defaultMessage: 'To continue creating a label, see notice above to either make a USPS account or to print a test label',
    id: 'UyHKsP',
  },
  minimumShipToNameLengthError: {
    description: 'labelBatchErrors.minimumShipToLengthError',
    defaultMessage: 'Recipient Name must contain at least two words. Each word must be at least two characters long, separated by a space.',
    id: '/rb5ZA',
  },
  minimumShipFromNameLengthError: {
    description: 'labelBatchErrors.minimumShipFromLengthError',
    defaultMessage: 'Ship From Name must contain at least two words. Each word must be at least two characters long, separated by a space.',
    id: 'KkmKc7',
  },
  nonClientDelagatedOrder: {
    description: 'labelBatchErrors.nonClientDelagatedOrder',
    defaultMessage:
      'The Client shipping service selected is only valid for client-delegated orders. You must select a non-client service for this order.',
    id: 'iYYnHl',
  },
  ProviderNotFound: {
    description: 'An error to display to users when the provider shipping service cannot be found for the seller',
    defaultMessage: 'This order does not have a shipping service selected.',
    id: 'MqJcXc',
  },
});
